
import { NgModule }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FiltroDinamicoComponent } from '../components/filtro-dinamico.component';
import { RespostaListaModule } from './resposta-lista-dinamica.module';
import { QuestionarioDinamicoService } from '../services/questionario-dinamico.service';

/** AngularMaterial **/
import {   MatSelectModule, MatButtonModule, MatIconModule, MatCheckboxModule, MatInputModule, MatRadioModule, MatProgressSpinnerModule, MatSnackBarModule } from '@angular/material';
import { HttpService } from 'ems-oauth2-client';

/**
Lista de Componentes do MaterialDesign (importar somento o q for usar)
MaterialModule, MdAutocompleteModule, MdCheckboxModule, MdInputModule, MdRadioModule, MdSelectModule, MdSliderModule, MdSlideToggleModule, MdMenuModule, MdSidenavModule, MdToolbarModule, MdListModule, MdGridListModule, MdCardModule, MdTabsModule, MdButtonModule, MdButtonToggleModule, MdChipsModule, MdIconModule, MdProgressSpinnerModule, MdDialogModule, MdTooltipModule, MdSnackBarModule
**/

@NgModule({
    declarations: [
        FiltroDinamicoComponent
    ],
    exports: [
      FiltroDinamicoComponent
    ],
    imports: [
      FormsModule, CommonModule, ReactiveFormsModule,
      MatSelectModule, MatButtonModule,  MatIconModule, MatInputModule, MatProgressSpinnerModule, MatSnackBarModule, MatRadioModule,
      RespostaListaModule
    ],
    providers: [QuestionarioDinamicoService, HttpService]
})
export class FiltroDinamicoModule {
}
